import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoMovimientoService } from 'src/app/services/tipo-movimiento.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-tipo-movimiento-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['./modal-add-edit.component.scss'],
  providers: [SecurityService],
})
export class ModalAddEditComponent implements OnInit {

  // Modales
  @ViewChild('agregarMotivo', { static: true }) modalAddEditMotivo: ModalDirective;

  @Output() onAddEdit: EventEmitter<any> = new EventEmitter()

  // Form
  formData: FormGroup

  // Data &  Tmp
  optionsOperaciones: Array<any> = [];
  isEditing: boolean = false
  codigoEditado = 0

  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
    private tipoMovimientoService: TipoMovimientoService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
  ) {
    this.log = this.clog.log('MODAL-ADD-EDIT-MOTIVO')
  }

  ngOnInit() {
    this.loadOperaciones()
    this.createForm()
  }

  loadOperaciones() {
    this.tipoMovimientoService.GetOperaciones(({ respuesta }) => {
      const { registros } = respuesta
      this.optionsOperaciones = registros.map(operacion => ({
        value: operacion.operacion,
        label: operacion.nombre
      }))
    })
  }

  private createForm() {
    this.formData = this.fb.group({
      activo: [false, [Validators.required]],
      nombre: [null, [Validators.required, Validators.maxLength(10)]],
      descripcion: [null, [Validators.required, Validators.maxLength(100)]],
      operacion: [null, [Validators.required]]
    });
  }

  show() {
    this.isEditing = false
    this.clearData()
    this.modalAddEditMotivo.show()
  }

  hide() {
    this.modalAddEditMotivo.hide()
  }

  load(tipoMovimiento) {
    this.isEditing = true
    this.codigoEditado = tipoMovimiento.codigo
    this.clearData()
    this.formData.get('activo').setValue(tipoMovimiento.activo)
    this.formData.get('nombre').setValue(tipoMovimiento.nombre)
    this.formData.get('descripcion').setValue(tipoMovimiento.descripcion)
    this.formData.get('operacion').setValue(tipoMovimiento.operacion)
    this.modalAddEditMotivo.show()
  }

  clearData() {
    this.formValidatorsService.reset(this.formData)
  }

  addEdit() {
    this.formValidatorsService.validateAllFormFields(this.formData)
    if (!this.formData.valid)
      return

    const inputParams: any = {
      entidad: {
        nombre: this.formData.get('nombre').value,
        descripcion: this.formData.get('descripcion').value,
        operacion: Number(this.formData.get('operacion').value),
        activo: this.formData.get('activo').value
      }
    }
    if (this.isEditing)
      inputParams.entidad.codigo = this.codigoEditado

    this.tipoMovimientoService.guardar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación realizada con éxito')
      this.onAddEdit.emit(respuesta)
      this.hide()
    })
  }

}

